import { useQuery } from '@tanstack/react-query';
import { turnsGetPrecedingAndFollowingTeams } from '~/generated';
import { extractData } from '~/utils/query-utils';

export const usePreceedingAndFollowingTurns = (args: { id: number }) =>
  useQuery({
    queryFn: async () =>
      extractData(
        turnsGetPrecedingAndFollowingTeams({ path: { turnId: args.id } })
      ),
    queryKey: ['turns', args.id, 'preceedingAndFollowingTurns'],
  });
